export type NotificationObstacleDetectionQuestionnaireItemType =
    | 'BOOLEAN'
    | 'MULTIPLE_CHOICE'
    | 'SWITCH'
    | 'LABEL'
    | 'DERIVED';

export type NotificationObstacleDetectionQuestionLabelType =
    | 'IS_OBSTACLE_PRESENT'
    | 'DID_OBSTACLE_COLLIDE_WITH_EXOS'
    | 'ENVIRONMENTAL_CONDITIONS'
    | 'GROUND_TYPE'
    | 'OBSTACLE_TYPE_PRESENT'
    | 'WAS_THERE_CONTACT_WITH_THE_OBSTACLE_IN_VIEW'
    | 'WAS_THE_CONTACT_CAUSED_BY_AN_ACTION_OF_THE_OBSTACLE';

export type NotificationObstacleDetectionDerivedQuestionType =
    | 'DID_THE_EXOS_DETECT_OBSTACLE'
    | 'IS_BUMPER_TRIGGERED'
    | 'CORRECT_OBSTACLE_CLASSIFICATION'
    | 'DID_EXOS_MAKE_PROTECTIVE_STOP'
    | 'MUST_STOP_FOR_OBSTACLE';

export const NotificationObstacleQuestionLabels: Record<NotificationObstacleDetectionQuestionLabelType, string> = {
    IS_OBSTACLE_PRESENT: 'Is er een obstakel aanwezig in het rijvlak van de EXOS?',
    DID_OBSTACLE_COLLIDE_WITH_EXOS: 'Is het obstakel in contact gekomen met de EXOS?',
    ENVIRONMENTAL_CONDITIONS: 'Welke omstandigheden zijn te zien op het beeld?',
    GROUND_TYPE: 'Wat is de ondergrond?',
    OBSTACLE_TYPE_PRESENT: 'Welke obstakels zijn er aanwezig in het rijvlak van de EXOS?',
    WAS_THERE_CONTACT_WITH_THE_OBSTACLE_IN_VIEW: 'Was er contact met het obstakel in beeld?',
    WAS_THE_CONTACT_CAUSED_BY_AN_ACTION_OF_THE_OBSTACLE: 'Is het contact veroorzaakt door een actie van het obstakel?',
};

export const CHOICES_ENVIRONMENTAL_CONDITIONS = [
    'Condens op de lens',
    'Druppels op de lens',
    'Goed belicht',
    'Hagel',
    'Mist',
    'Niet belicht',
    'Opgewaaid stof in de lucht',
    'Redelijk belicht',
    'Regen',
    'Schaduw valt (gedeeltelijk) over het obstakel',
    'Sneeuw',
    'Verblind door verlichting',
    'Verblind door zonlicht',
    'Vieze lens',
];

export const CHOICES_GROUND_TYPE = [
    'Gras (gras)',
    'Onverhard (grind)',
    'Onverhard (onverhard)',
    'Sloot (water)',
    'Sneeuw (sneeuw)',
    'Weg (asfalt)',
    'Weg (bestrating)',
    'Weg (beton)',
];

export const CHOICES_OBSTACLE_TYPE = [
    'Bakstenen muur',
    'Constructie',
    'Dier',
    'Exos',
    'Hek',
    'Koe',
    'Lader',
    'Lely voertuig',
    'Materiaal',
    'Onduidelijk',
    'Onverhard',
    'Persoon',
    'Sloot',
    'Struikgewas',
    'Vegetatie',
    'Voer',
    'Voerhek',
    'Voertuig',
    'Vogels',
];

export const SHOULD_STOP_FOR_OBSTACLE_TYPES = [
    'Persoon',
    'Koe',
    'Dier',
    'Voertuig',
    'Materiaal',
    'Constructie',
    'Hek',
    'Voerhek',
    'Sloot',
    'Voer',
    'Bakstenen muur',
    'Lely voertuig',
    'Struikgewas',
];

export type NotificationObstacleDetectionLabelType =
    | 'BUMPER_HIT_BEYOND_CONTROL_OF_EXOS'
    | 'BUMPER_HIT_DUE_TO_FAILED_CLASSIFICATION'
    | 'BUMPER_HIT_DUE_TO_FAILED_ODS'
    | 'BUMPER_HIT_DUE_TO_FAILED_PROTECTIVE_STOP'
    | 'BUMPER_HIT_DUE_TO_OBSTACLE_OUT_OF_SIGHT'
    | 'CORRECT_CLASSIFICATION'
    | 'CRASH_EVENT_BEYOND_CONTROL_OF_EXOS'
    | 'CRASH_EVENT_DUE_TO_FAILED_CLASSIFICATION'
    | 'CRASH_EVENT_DUE_TO_FAILED_OBSTACLE_DETECTION'
    | 'CRASH_EVENT_DUE_TO_FAILED_PROTECTIVE_STOP'
    | 'CRASH_EVENT_DUE_TO_OBSTACLE_OUT_OF_SIGHT'
    | 'DEFUSED_COLLISION_EVENT'
    | 'FAILED_PROTECTIVE_STOP'
    | 'FALSE_NEGATIVE'
    | 'FALSE_POSITIVE'
    | 'INCORRECT_CLASSIFICATION'
    | 'INTENTIONAL_BUMPER_HIT'
    | 'NOT_A_POTENTIAL_COLLISION_EVENT'
    | 'NO_COLLISION_SUCCESFUL_PROTECTIVE_STOP_DUE_TO_ODS'
    | 'OTHER'
    | 'POTENTIAL_COLLISION_EVENT'
    | 'PROTECTIVE_STOP_BUT_INCORRECT_OBSTACLE_CLASSIFICATION'
    | 'SUCCESFULLY_IGNORED_OBSTACLE'
    | 'SUCCESFUL_PROTECTIVE_STOP_DUE_TO_ODS'
    | 'TRUE_NEGATIVE'
    | 'TRUE_POSITIVE';
